import service, { serviceGo } from "@/utils/request";

export function login(data: { username: string, password: string }) {
  return service.post('/api/auth/login', data)
}

// 微信网站应用扫码登录：用回跳带回的 code 换取后台 token（仅匹配已有 admin/author/editor 用户）
export function backendWxLogin(code: string) {
  return serviceGo.post('/api_v2/backend/wx/login', { code }, { _silentError: true } as any)
}

// 扫码登录回跳地址：优先用环境变量，否则取当前站点 origin
export function getWxRedirectUri(): string {
  return process.env.VUE_APP_WX_REDIRECT_URI
    || `${window.location.origin}/wx-login-callback`
}

// 拼接微信开放平台「网站应用」扫码登录 URL
export function getWxQrConnectUrl(state: string): string {
  const appid = process.env.VUE_APP_WX_WEBAPP_ID || ''
  const redirectUri = encodeURIComponent(getWxRedirectUri())
  return `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}` +
    `&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login` +
    `&state=${encodeURIComponent(state)}#wechat_redirect`
}

// QQ 互联「网站应用」扫码登录：用回跳带回的 code 换取后台 token（仅匹配已有 admin/author/editor 用户）
export function backendQqLogin(code: string) {
  return serviceGo.post('/api_v2/backend/qq/login', { code }, { _silentError: true } as any)
}

// QQ 扫码登录回跳地址：优先用环境变量，否则取当前站点 origin
export function getQqRedirectUri(): string {
  return process.env.VUE_APP_QQ_REDIRECT_URI
    || `${window.location.origin}/qq-login-callback`
}

// 拼接 QQ 互联「网站应用」扫码登录授权 URL
export function getQqAuthorizeUrl(state: string): string {
  const appid = process.env.VUE_APP_QQ_WEBAPP_ID || ''
  const redirectUri = encodeURIComponent(getQqRedirectUri())
  return `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${appid}` +
    `&redirect_uri=${redirectUri}&state=${encodeURIComponent(state)}&scope=get_user_info`
}